module.exports = __webpack_public_path__ + "img/portfolio-what.de116bf7.svg";